<template>
<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
  <van-list
    v-model="loading"
    :finished="finished"
    :finished-text="finishedText"
    @load="onLoad"
  >
    <slot></slot>
  </van-list>
</van-pull-refresh>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default() {
        return {}
      },
    },
    requestUrl: {
      type: String,
      default: '',
    },
    finishedText: {
      type: String,
      default: '没有更多了'
    },
    reload: {}
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      pager: {
        pageNum: 1,
        pageSize: 15,
      }
    }
  },
  watch: {
    'reload'(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.pager.pageNum = 1
        this.list = []
        this.finished = false
        this.$emit('loaded', this.list)
        this.onLoad()
      }
    },
  },
  created() {

  },
  methods: {
    onLoad() {
      this.$http.get(this.requestUrl, {...this.pager, ...this.query}).then(res => {
        this.loading = false
        this.refreshing = false
        const { rows, pageNum, pageSize, total } = res
        Object.assign(this.pager, {pageNum, pageSize})

        const pageCount = Math.ceil(total/pageSize) || 1
        // 是否是最后一页
        const isLastPage = pageCount === pageNum
        
        if(pageNum > pageCount) return
        if(pageNum === 1) {
          this.list = rows
        } else {
          this.list = this.list.concat(rows)
        }
        this.pager.pageNum += 1
        this.finished = !!isLastPage
        this.$emit('loaded', this.list)
      })
    },
    onRefresh() {
      this.pager.pageNum = 1
      // 重新加载当前页数据
      this.$nextTick(() => {
        this.onLoad()
      })
    },
  },
}
</script>

<style>

</style>